// @flow
import React from 'react';

import { BaseHeading } from './BaseHeading';

export const StyledH4 = ({ text, inline = false }) => (
  <BaseHeading as="h4" inline={inline} text={text} />
);
